import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiCreateTask, type CreateTaskInput } from '../api/tasks.api';

export function useCreateTask(projectId: string) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (input: CreateTaskInput) => apiCreateTask(projectId, input),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['tasks', projectId] }),
    });
}
